import { useI18nStore } from '../../shared/i18n/i18nStore';

/**
 * MADURO 横幅。视觉规格 §7。
 *
 * <p>只在 `state = MADURO` 时渲染，插在奖池头与选号器之间。
 *
 * <p>**无动效**（§2.1）。金色实底徽章是全稿唯一的金色实底非 CTA 元素 ——
 * 这是静态手段能达到的最强对比，用来把 MADURO 从常态里拎出来。加动效会让它
 * 和主 CTA 抢注意力，而主 CTA 才是要被点的那个。
 *
 * @param winningDigits 降档后的中奖门槛位数，由后端下发。**不要写死 3** ——
 *                      不同档位（4/5/6 位）降完是不一样的数。
 */
export function MaduroBanner({ winningDigits }: { winningDigits: number }) {
  const t = useI18nStore((state) => state.t);
  return (
    <div className="milhar-maduro" role="status">
      <span className="milhar-maduro-badge">{t('milharMaduroBadge')}</span>
      <span className="milhar-maduro-text">
        <b className="milhar-maduro-main">
          {t('milharMaduroMain').replace('%n%', String(winningDigits))}
        </b>
        <span className="milhar-maduro-sub">{t('milharMaduroSub')}</span>
      </span>
    </div>
  );
}
